import React, { FC, useMemo, useState } from 'react'
import { graphql } from 'gatsby'
import Box from '@/atoms/Box'
import Text from '@/atoms/Text'
import ReactPlayer from 'react-player'
import { SanityImage as SanityImageType, SanityModuleDefaultFields, SanityVideoEmbed } from 'web/types/graphql-types'
import SanityImage from '@/atoms/SanityImage'

export interface VideoEmbedModuleProps {
  _key?: string;
  _type?: string;
  options?: SanityModuleDefaultFields;
  title?: string;
  video?: SanityVideoEmbed;
  posterFrame?: SanityImageType;
  muted?: boolean;
  controls?: boolean;
  loop?: boolean;
  autoplay?: boolean;
  aspectRatio: { x: number, y: number };
};


const VideoEmbedModule: FC<VideoEmbedModuleProps> = ({
  video,
  autoplay,
  controls,
  loop,
  muted,
  title,
  posterFrame,
  aspectRatio
}) => {
  const [playing, setPlaying] = useState(autoplay)
  const [loading, setLoading] = useState(true)


  const width = aspectRatio.x / aspectRatio.y
  const height = aspectRatio.y / aspectRatio.x


  return (
    <>
      {title && <Text as="h2" variant="head" mb={1}>{title}</Text>}
        <Box
          position="absolute"
          minWidth={`calc(100vh * ${width})`}
          minHeight={`calc(100vw * ${height})`}
          width="100%"
          height="100%"
          top="50%"
          left="50%"
          style={{
              transform: 'translate(-50%, -50%)',
              pointerEvents: 'none',
            }}
          >
          {loading && <SanityImage image={posterFrame} />}
          {video?.url && <ReactPlayer
            onPlay={() => setLoading(false)}
            // onReady={() => setLoading(false)}
            url={video.url}
            controls={controls}
            loop={loop}
            muted={muted || autoplay}
            playsinline={true}
            playing={playing}
            light={autoplay ? false : (posterFrame?.asset?.url ? posterFrame?.asset?.url : false)}
            width="100%"
            height="100%"
            style={{objectFit: 'cover'}}
          />}
        </Box>
    </>
  )
}

export default VideoEmbedModule

export const query = graphql`
  fragment moduleVideoEmbedData on SanityModuleVideoEmbed {
    autoplay
    controls
    loop
    muted
    title
    video {
      url
    }
    aspectRatio {
      x
      y
    }
    posterFrame {
      ...ImageWithPreview
      asset {
        url
      }
    }
  }
`

// fragment Image on SanityImage {
//   hotspot {
//     height
//     width
//     x
//     y
//   }
//   crop {
//     bottom
//     left
//     right
//     top
//   }
//   asset {
//     _id
//     altText
//   }
// }

// fragment ImageWithPreview on SanityImage {
//   ...Image
//   asset {
//     metadata {
//       preview: lqip
//     }
//   }